/* eslint-disable default-param-last */
import {
  GET_ACTIVITIES,
  GET_EVENTS,
  RESET_ACTIVITIES_AND_EVENTS,
  GET_EVENTS_BY_ID,
  GET_EVENTS_USERS,
  GET_EVENT_PARTICIPANTS_DETAILS,
  GET_MANUAL_EVENT_RESULT_DETAIL,
  GET_RESULT_CATEGORIES_DETAIL,
  GET_CATEGORY_DETAIL,
} from '../actionTypes';

const initialState = {
  activities: [],
  events: [],
  eventsById: {},
  registeredUsers: {},
  activitiesAndEventsDetails: null,
  eventParticipantDetails: [],
  manualEventResultDetail: {},
  resultCategoriesDetail: [],
  categoryParticipantList: [],
};

const activitiesAndEventsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACTIVITIES:
      return {
        ...state,
        activities: action.payload,
      };
    case GET_EVENTS:
      return {
        ...state,
        events: action.payload,
      };
    case RESET_ACTIVITIES_AND_EVENTS:
      return {
        ...state,
        activitiesAndEventsDetails: null,
      };
    case GET_EVENTS_BY_ID:
      return {
        ...state,
        eventsById: action.payload,
      };
    case GET_EVENTS_USERS:
      return {
        ...state,
        registeredUsers: action.payload,
      };
    case GET_EVENT_PARTICIPANTS_DETAILS:
      return {
        ...state,
        eventParticipantDetails: action.payload,
      };
    case GET_MANUAL_EVENT_RESULT_DETAIL:
      return {
        ...state,
        manualEventResultDetail: action.payload,
      };
    case GET_RESULT_CATEGORIES_DETAIL:
      return {
        ...state,
        resultCategoriesDetail: action.payload,
      };
    case GET_CATEGORY_DETAIL:
      return {
        ...state,
        categoryParticipantList: action.payload,
      };
    default: {
      return state;
    }
  }
};

export default activitiesAndEventsReducer;
